export interface Attendee {
    email: string | null;          // can be empty string or valid email
    name: string;
    role: string;
    phone: string | null;
    isMemberExcused: boolean | null;
    bilingual: boolean | null;
    isParticipated: boolean | null;
    isSign: string;                // e.g., "empty"
}

export interface MeetingRecord {
    requiredAttendees: Attendee[];
    optionalAttendees: Attendee[];
    student: Attendee[];
    isSigned: boolean | null;
    origScheduleEndDt: string | null;
}

export type MeetingRecordList = MeetingRecord[];


export class MeetingRequestModel {
    studentSKs: string[];   // Array of GUIDs
    meetingType: number;    // Example: 4
    constructor(data: MeetingRequestModel) {
        this.studentSKs = data?.studentSKs;
        this.meetingType = data?.meetingType;
    }
}

export class EvaluationAttendeesRequest {
    StudentSK: string;   // Array of GUIDs
    meetingType: number;    // Example: 4
    constructor(data: EvaluationAttendeesRequest) {
        this.StudentSK = data?.StudentSK;
        this.meetingType = data?.meetingType;
    }
}